/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import { setSelectedChannelByProduct } from './helpers/uiAdapter';

export const setSelectedProductChannel = createAction('products/setSelectedProductChannel');

export const reducer = (builder) => {
  builder
    .addCase(setSelectedProductChannel, (state, { payload }) => {
      const { productId, channelId } = payload;
      setSelectedChannelByProduct(state, productId, channelId);
    });
};
